(() => {
  const root = document.querySelector("main") || document.body;

  // Fame/Flickity Active Slide
  const ACTIVE_SELECTOR = ".product__img-item.is-selected";
  const ACTIVE_VIDEO_SELECTOR = `${ACTIVE_SELECTOR} video`;

  let lastVideo = null;

  function getActiveVideo() {
    return root.querySelector(ACTIVE_VIDEO_SELECTOR);
  }

  function setup(v) {
    if (!v) return;

    // Autoplay-sicher: immer muted starten
    v.muted = true;
    v.defaultMuted = true;
    v.setAttribute("muted", "");
    v.playsInline = true;
    v.setAttribute("playsinline", "");
    v.loop = true;
    v.setAttribute("loop", "");
    v.preload = "auto";
    v.setAttribute("preload", "auto");

    v.setAttribute("controlsList", "nodownload noplaybackrate");
    v.setAttribute("disablepictureinpicture", "");
    v.disablePictureInPicture = true;

    try { v.load(); } catch (e) {}
  }

  function play(v) {
    if (!v) return;
    setup(v);

    try {
      const p = v.play();
      if (p && p.catch) p.catch(() => {});
    } catch (e) {}
  }

  function pauseOthers(active) {
    root.querySelectorAll(".product__img video").forEach(v => {
      if (v !== active) {
        try { v.pause(); } catch (e) {}
      }
    });
  }

  function sync() {
    const v = getActiveVideo();
    if (!v) return;

    // NUR wenn sich das aktive Video wirklich ändert
    if (v !== lastVideo) {
      lastVideo = v;
      pauseOthers(v);
      play(v);

      // Einmaliger Retry, falls Theme kurz nach Init pausiert
      setTimeout(() => {
        if (getActiveVideo() === v && v.paused) play(v);
      }, 250);
    } else {
      // Falls Theme pausiert hat: nur dann wieder starten
      if (v.paused) play(v);
    }
  }

  // Initial (Slider init + lazyload)
  document.addEventListener("DOMContentLoaded", () => {
    sync();
    setTimeout(sync, 300);
    setTimeout(sync, 900);
    setTimeout(sync, 1600);
  });

  window.addEventListener("load", () => {
    sync();
    setTimeout(sync, 300);
  });

  // Beobachte nur Klassenwechsel (NICHT style!)
  const mo = new MutationObserver(() => requestAnimationFrame(sync));
  mo.observe(root, {
    subtree: true,
    attributes: true,
    attributeFilter: ["class", "aria-hidden", "aria-current"]
  });

  // Fallback: falls Script spät geladen wird
  sync();
})();


document.addEventListener("pointerdown", () => {
  const v = document.querySelector(".product__img-item.is-selected video");
  if (!v) return;
  v.muted = false;
  v.defaultMuted = false;
  v.removeAttribute("muted");
  v.volume = 0.4;
  try { v.play(); } catch (e) {}
}, { once: true, capture: true });
